import { useState, useEffect } from 'react';
import { ShippingAPI } from '../services/api';
import { useCart } from '../contexts/CartContext';

const useShippingOptions = (country = 'BG') => {
  const { cart, dispatch } = useCart();
  const [shippingOptions, setShippingOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchShippingOptions = async () => {
      if (cart.items.length === 0) {
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const response = await ShippingAPI.calculateShipping(
          cart.items,
          { country: country || 'BG' }
        );
        setShippingOptions(response.shipping_options || []);
      } catch (err) {
        console.error('Грешка при извличане на опции за доставка:', err);
        setError('Неуспешно зареждане на опции за доставка. Моля, опитайте отново по-късно.');
      } finally {
        setLoading(false);
      }
    };

    fetchShippingOptions();
  }, [cart.items, country]);

  const handleSelectShippingMethod = (method) => {
    dispatch({
      type: 'SET_SHIPPING_METHOD',
      payload: method
    });
  };

  return {
    shippingOptions,
    loading,
    error,
    handleSelectShippingMethod
  };
};

export default useShippingOptions; 